<template>
  <div
    v-if="visible"
    class="dialog-overlay"
    @click="closeDialog"
  >
    <div
      class="dialog-content"
      @click.stop
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible'],
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
